<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Gestión de precios</h1>
                <br>
                <v-card>
                    <v-card-text>
                        <form @submit.prevent="agregar()" ref="form" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <v-autocomplete clearable label="Tipo de producto" v-model="d.item_tipos_id" :items="item_tipos" item-value="id" item-text="desig" @change="tabla()"></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <item-select v-model="item" :id.sync="d.item_id" :tipo="d.item_tipos_id" @change="tabla()"></item-select>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap>
                                <v-flex xs12 sm2>
                                    <v-text-field clearable label="Valor" v-model="d.valor"></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-btn type="submit" dark color="green" :loading="loading">
                                        <v-icon left>add</v-icon>
                                        Agregar
                                    </v-btn>
                                    <!--<v-btn dark color="primary" @click="calcula()">-->
                                    <!--<v-icon left>fa-calculator</v-icon>-->
                                    <!--calcula-->
                                    <!--</v-btn>-->
                                    <v-btn dark color="orange" @click="informe()" :loading="loadingInforme">
                                        <v-icon left>cloud_download</v-icon>
                                        informe
                                    </v-btn>
                                    <v-btn dark color="orange" @click="panelSinPrecio()" :loading="loadingInfPan">
                                        <v-icon left>cloud_download</v-icon>
                                        Paneles sin Precio
                                    </v-btn>
                                </v-flex>
                                <!--<v-flex sm2 xs12>-->
                                <!--<v-text-field-->
                                <!--label="Porcentaje de aumento"-->
                                <!--v-model="porcent.valor"-->
                                <!--:hint="porcent.desc"-->
                                <!--persistent-hint-->
                                <!--@change="configGuardar()"-->
                                <!--&gt;</v-text-field>-->
                                <!--</v-flex>-->
                            </v-layout>
                        </form>
                        <v-layout>
                            <v-flex>
                                <v-data-table
                                        :headers="headers"
                                        :items="items"
                                        :pagination.sync="pag"
                                        :total-items="totalItems"
                                        :loading="loading"
                                        rows-per-page-text="Filas por pagina"
                                        no-data-text="No hay datos"
                                        disable-initial-sort
                                        item-key="id"
                                        class="tabla-compacta-col"
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr @click="props.selected = !props.selected" @dblclick="props.expanded = !props.expanded">
                                            <td class="text-xs-center">{{ props.item.created_at }}</td>
                                            <td class="text-xs-center">{{ props.item.updated_at }}</td>
                                            <td class="text-xs-center">{{ props.item.item_tipo }}</td>
                                            <td class="text-xs-left">
                                                <div v-if="props.item.micro_id_1">FRIOLATINA: {{ props.item.micro_id_1 }}</div>
                                                <div v-if="props.item.micro_id_2">BERVILL: {{ props.item.micro_id_2 }}</div>
                                                <div v-if="props.item.micro_id_3">ACEROLATINA: {{ props.item.micro_id_3 }}</div>
                                            </td>
                                            <td class="text-xs-left">{{ props.item.descripcion }}</td>
                                            <td class="text-xs-left">{{ props.item.um }}</td>
                                            <td class="text-xs-right">
                                                <v-edit-dialog
                                                        save-text="Guardar"
                                                        cancel-text="Cancelar"
                                                        large
                                                        lazy
                                                        style="width: 100%"
                                                        @save="editar(props.item)">
                                                    <span style="width: 100%">{{ (props.item.valor)?props.item.valor : 0 | moneda }}</span>
                                                    <v-text-field
                                                            slot="input"
                                                            v-model="precioNuevo"
                                                            label="Editar"
                                                            single-line
                                                            type="number"
                                                            hint="Presione <kbd>enter</kbd> para guardar"
                                                    >
                                                    </v-text-field>
                                                </v-edit-dialog>
                                            </td>
                                            <td class="text-xs-center">
                                                <v-btn flat icon @click.native="eliminar(props.item.ident)" color="red" :loading="loadingDel === props.item.ident">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import moneda from '../../filters/moneda';
    import mixinPrecio from '../../mixins/precios';
    import mixinConfig from '../../mixins/config';
    import {mapActions} from 'vuex';
    import itemSelect from '../../components/ItemSelect';
    import saveAs from 'file-saver';

    export default {
        name: "costo-config",
        filters: {moneda},
        mixins: [mixinPrecio, mixinConfig],
        components: {itemSelect},
        data() {
            return {
                porcent: {
                    desc: '',
                    valor: ''
                },
                item: {},
                d: {
                    item_tipos_id: '5',
                    item_id: '',
                    tipo_panel: '',
                    nucleo: '',
                    esp: '',
                    densidad: '',
                    ext_esp: '',
                    ext_rev: '',
                    int_esp: '',
                    int_rev: '',
                    valor: 0,
                },
                loading: false,
                loadingAdd: false,
                loadingDel: -1,
                pag: {},
                totalItems: 0,
                tipo_panel: [],
                item_tipos: [],
                nucleo: [],
                esp: [],
                densidad: [],
                cara_esp: [],
                cara_rev: [],
                items: [],
                precioNuevo: '',
                loadingInforme: false,
                loadingInfPan: false,
                posiciones: [],
                codigo: '',
                headers: [
                    {text: 'F. Creación', value: 'created_at', align: 'center'},
                    {text: 'F. Actualiz.', value: 'updated_at', align: 'center'},
                    {text: 'Tipo Item', value: 'item_tipos_id', align: 'center'},
                    {text: 'Cód', value: 'item_id', align: 'center'},
                    {text: 'Item', value: 'items.descripcion', align: 'center'},
                    {text: 'UM', value: 'um', align: 'center'},
                    {text: 'Valor', value: 'valor', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ]
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        mounted() {
            this.datos();
            this.configGetAll('precioPorc', r => {
                this.porcent = r;
            }, err => {
                console.error('Error al obtener configuracion de porcentaje')
            });
            this.codigos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            ...mapActions('progreso', ['progresoShow', 'progresoHide', 'progresoPorcent']),
            editar(item) {
                this.loading = true;
                item.valor = this.precioNuevo;
                this.precioNuevo = '';
                this.precioUpdate(item, r => {
                    this.msjShow({txt: 'Modificación guardada', tipo: 'ok'});
                    this.loading = false;
                }, err => {
                    console.error('Error');
                    this.loading = false;
                });
                return false;
            },
            informe() {
                this.loadingInforme = true;
                this.$http({
                    method: 'post',
                    url: 'precio/informe',
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        saveAs(response.data, 'precios.xlsx');
                        this.loadingInforme = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loadingInforme = false;
                    });
            },
            panelSinPrecio() {
                this.loadingInfPan = true;
                this.$http({
                    method: 'post',
                    url: 'precio/paneles-sin-precio',
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        saveAs(response.data, 'paneles-sin-precio.xlsx');
                        this.loadingInfPan = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loadingInfPan = false;
                    });
            },
            calcula() {
                if (!this.d.item_tipos_id) {
                    this.msjShow({txt: 'Debe seleccionar un tipo de producto', tipo: 'error'})
                    return false;
                }
                let url = window.Laravel.urlBase + '/precio/lista-generar?item_tipos_id=' + this.d.item_tipos_id;
                let es = new EventSource(url);
                this.progresoShow({tit: 'Procesando lista de precios'});
                es.addEventListener('message', event => {
                    let data = JSON.parse(event.data);
                    if (data.prog === 'fin') {
                        es.close();
                        this.tabla();
                        this.progresoHide();
                    } else {
                        this.progresoPorcent({porcent: data.prog})
                    }
                });
                es.addEventListener('error', event => {
                    if (event.readyState === EventSource.CLOSED) {
                        console.log('Event was closed');
                        console.log(EventSource);
                    }
                    console.log(event);
                    this.progresoHide();
                }, false);
            },
            datos() {
                this.precioDatos(r => {
                    this.tipo_panel = r.tipo_panel;
                    this.item_tipos = r.item_tipos;
                    this.nucleo = r.nucleo;
                    this.esp = r.esp;
                    this.cara_esp = r.cara_esp;
                    this.cara_rev = r.cara_rev;
                    this.densidad = r.densidad;
                }, err => {
                    console.log(err);
                });
            },
            tabla() {
                this.loading = true;
                this.pag.filtros = this.d;
                this.precioIndex(this.pag, r => {
                    this.totalItems = r.total;
                    this.items = r.data;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            agregar() {
                this.loading = true;
                this.precioStore(this.d, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al guardar', tipo: 'error'})
                    this.loading = false;
                });
            },
            eliminar(id) {
                this.loadingDel = id;
                this.precioDestroy(id, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.loadingDel = -1;
                }, err => {
                    this.msjShow({txt: 'Error al eliminar', tipo: 'error'});
                    this.loadingDel = -1;
                });
            },
            configGuardar() {
                this.configSet({
                    valor: this.porcent.valor, id: this.porcent.id
                }, r => {
                    this.msjShow(r);
                }, err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/precios/gestion.vue